import axios from 'axios';

export const sendContactEmail = async (formData) => {
  const { name, phone, email, description } = formData;
  return axios.post(
    "AMAZON EMAIL API URI",
    { name, phone, email, description }
  );
};